var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawVibeCodingMjme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 799.031,
    height: 756.496,
    viewBox: "0 0 799.031 756.496",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-560 -170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.18,488.763c0,.872.478,1.573,1.073,1.573h535.1c.6,0,1.073-.7,1.073-1.573s-.478-1.573-1.073-1.573H16.253C15.658,487.191,15.18,487.891,15.18,488.763Z",
    transform: "translate(675.48 436.16)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.105,
    height: 3.371,
    transform: "translate(865.162 919.738)",
    fill: "#b6b3c5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.105,
    height: 3.371,
    transform: "translate(1034.295 920.301)",
    fill: "#b6b3c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.955,370.945a27.529,27.529,0,0,1-54.321,0H229.146V521.536h193.3V370.945H352.955Z",
    transform: "translate(633.721 398.762)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 193.296,
    height: 5.242,
    transform: "translate(863.43 908.367)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.255,487.17H10.776A10.788,10.788,0,0,1,0,476.394V32.688A10.788,10.788,0,0,1,10.776,21.911H788.255a10.789,10.789,0,0,1,10.776,10.776V476.394a10.789,10.789,0,0,1-10.776,10.776Z",
    transform: "translate(560 286.473)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 760.822,
    height: 429.297,
    transform: "translate(579.104 326.363)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 405.085,
    height: 245.866,
    rx: 8,
    transform: "translate(668.429 418.08)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 388.981,
    height: 230.626,
    transform: "translate(675.989 425.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 149.174,
    height: 113.965,
    rx: 8,
    transform: "translate(1101.429 418.08)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 134.349,
    height: 102.639,
    transform: "translate(1108.841 423.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 149.174,
    height: 113.965,
    rx: 8,
    transform: "translate(1101.429 549.979)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 134.349,
    height: 102.639,
    transform: "translate(1108.841 555.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11934.972 -22137.148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.732,321.291a28.068,28.068,0,0,0-11.651-13.848,54.746,54.746,0,0,0-18.895-7.189,49.29,49.29,0,0,0-19.8,1.108c-3.113.806-6.545,1.743-9.171,3.673-2.51,1.846-4.229,4.881-5.629,7.609-1.341,2.613-2.177,5.49-1.451,8.417a12.659,12.659,0,0,0,4.678,6.633c1.911,1.51,4.584,3.508,7.14,2.573a1.994,1.994,0,0,0,.413-.208c4.414,1.343,8.8-.61,13.335-2.14,2.754-.93,5.523-1.4,8.289-.239a15.526,15.526,0,0,1,6.569,5.809c1.547,2.3,2.565,4.917,4.261,7.124a10.122,10.122,0,0,0,7.155,4.04c5.475.613,12.742.048,15.9-5.136C390.228,333.992,388.029,326.789,385.732,321.291Zm-55.891-8.484,2.437.276a9.009,9.009,0,0,0-4.2,1.969,10.7,10.7,0,0,0-1.269,1.268c.011-.037.018-.072.03-.11A5.666,5.666,0,0,1,329.841,312.806Zm27.264,5.186a1.394,1.394,0,0,0,.612.261l.078.013q.226.13.454.258c-.017.024-.03.05-.046.075l-1.114-.112A1.953,1.953,0,0,0,357.105,317.993Zm9.828,11.621a1.624,1.624,0,0,0-.216.285l-.109-.159a1.076,1.076,0,0,1,.325-.126Zm6.347,6.87,1.1.145a1.4,1.4,0,0,0-.15.383c-.261.009-.524.013-.787.014Zm5.331-3.133.444-.076a1.617,1.617,0,0,0,.649-.258c0,.026,0,.052,0,.078,0,.089.012.2.023.325-.036.064-.073.127-.112.19l-1.008-.259Zm-18.93-19.577a2.12,2.12,0,0,0-.591-.348,25.561,25.561,0,0,0-3.2-1q-.244-.229-.476-.471a25.731,25.731,0,0,1,2.715.691,31.618,31.618,0,0,1,3.36,1.292q-.907-.1-1.812-.165Zm10.2.683q-.8-.5-1.606-.979.828.467,1.633.979Zm10.995,5.018a38.361,38.361,0,0,0-4.716-4.83,2.348,2.348,0,0,0,.2-.963A24.236,24.236,0,0,1,380.873,319.476Zm-20.505-14.284-.677-.156c-2.144-.484-4.327-1.005-6.531-1.447.118.014.236.025.354.04a38.052,38.052,0,0,1,6.853,1.563Z",
    transform: "translate(-11116.219 22281.789)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.106,447.6c-2.04-.057-4.58-.128-6.535-1.557a5.019,5.019,0,0,1-1.975-3.747,3.376,3.376,0,0,1,1.148-2.772,4.356,4.356,0,0,1,4.121-.593L419.2,426.755l1.223-.168,1.958,14.31-1.021-.469c-1.184-.543-2.809-.819-3.819.034a2.168,2.168,0,0,0-.711,1.786,3.793,3.793,0,0,0,1.469,2.794c1.521,1.112,3.545,1.255,5.841,1.32Z",
    transform: "translate(-11178.093 22200.635)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.647,
    height: 1.234,
    transform: "translate(-10771.587 22628.439)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.647,
    height: 1.234,
    transform: "translate(-10750.606 22628.439)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.285,322.508c-5.353-.61-9.5-5.739-9.953-10.942-.542-6.191,3.063-12.07,8.01-15.544,5.172-3.633,11.617-5.15,17.852-5.484a49.063,49.063,0,0,1,33.537,11.054c4.672,3.88,9.036,8.823,10.689,14.794,1.436,5.185.267,11.059-3.9,14.691a9.858,9.858,0,0,1-7.565,2.329c-3.236-.336-6.221-2.037-8.806-3.917-5.027-3.655-9.154-8.747-15.279-10.657-4.491-1.4-10.319-.168-13.063,3.893a7.392,7.392,0,0,0-1.18,3.1.959.959,0,0,0,.646,1.139.931.931,0,0,0,1.139-.646c.72-5.115,7.01-7.024,11.424-5.856,6.435,1.7,10.755,7.446,16.035,11.094a19.486,19.486,0,0,0,9.338,3.727,11.6,11.6,0,0,0,8.147-2.5c4.511-3.562,6.236-9.688,5.238-15.2-1.155-6.387-5.454-11.861-10.171-16.1a50.875,50.875,0,0,0-34.768-12.844c-6.525.15-13.332,1.5-18.953,4.945-5.452,3.345-9.666,8.941-10.217,15.446a14.583,14.583,0,0,0,7.861,14.223,12.309,12.309,0,0,0,3.944,1.113c1.182.135,1.172-1.718,0-1.851Z",
    transform: "translate(-11120.42 22288.889)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0.014, -0.014, 1, 10755.333, -21549.832)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.141,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9721.341 22148.283) rotate(-1)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.141,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9633.358 22146.754) rotate(-1)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.141,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9608.434 22146.314) rotate(-1)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.266,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9697.423 22147.162) rotate(-1)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.266,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9580.115 22145.111) rotate(-1)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.141,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9720.691 22167.34) rotate(-1)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.141,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9632.711 22165.811) rotate(-1)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.141,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9607.783 22165.371) rotate(-1)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.266,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9696.773 22166.219) rotate(-1)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.266,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9579.466 22164.172) rotate(-1)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.141,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9673.752 22185.594) rotate(-1)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.141,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9585.77 22184.059) rotate(-1)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.141,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9560.842 22183.619) rotate(-1)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.266,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9649.832 22184.467) rotate(-1)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.141,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9719.672 22242.281) rotate(-1)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.141,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9694.746 22241.846) rotate(-1)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.266,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9666.402 22242.055) rotate(-1)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.141,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9655.808 22222.098) rotate(-1)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.141,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9630.878 22221.664) rotate(-1)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.266,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9719.846 22223.92) rotate(-1)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.266,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9602.536 22221.871) rotate(-1)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.141,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9673.443 22203.336) rotate(-1)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.141,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9585.463 22201.803) rotate(-1)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.141,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9560.533 22201.363) rotate(-1)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.266,
    height: 8.447,
    rx: 2.88,
    transform: "translate(-9649.499 22203.623) rotate(-1)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.167,
    cy: 4.167,
    r: 4.167,
    transform: "matrix(0.966, 0.259, -0.259, 0.966, -9690.37, 22202.391)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.167,
    cy: 4.167,
    r: 4.167,
    transform: "matrix(0.966, 0.259, -0.259, 0.966, -9690.718, 22184.801)",
    fill: "#4f7777"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9927.105 -20746.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.071,194.923,329.5,205.113a5.232,5.232,0,0,1-6.365-3.758l-11.967-46.472a5.232,5.232,0,0,1,3.758-6.365l36.814-9.48,9.423,4.218,11.666,45.3A5.232,5.232,0,0,1,369.071,194.923Z",
    transform: "translate(-9113.003 21169.963)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.3,158.415a3.726,3.726,0,0,0-2.676,4.532l11.967,46.473a3.726,3.726,0,0,0,4.532,2.676l39.571-10.19a3.726,3.726,0,0,0,2.676-4.532l-11.485-44.6-8.281-3.707Z",
    transform: "translate(-9120.998 21161.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.061,144.156l-6.124,1.577a1.741,1.741,0,0,1-2.12-1.252l-1.165-4.523a.109.109,0,0,1,.149-.127l9.276,4.12a.109.109,0,0,1-.017.2Z",
    transform: "translate(-9329.002 21169.303)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.218,408.66,487.2,413.3a.87.87,0,1,1-.434-1.686l18.016-4.639a.87.87,0,1,1,.434,1.686Z",
    transform: "translate(-9260.381 20944.484)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.32,420.968,491.827,426.5a.87.87,0,1,1-.434-1.686l21.493-5.535a.87.87,0,0,1,.434,1.686Z",
    transform: "translate(-9264.273 20934.125)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.076,
    cy: 3.076,
    r: 3.076,
    transform: "translate(-8783.607 21357.219)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.971,235.259l-23.927,6.159a2.7,2.7,0,0,1-3.279-1.936L390.752,220a2.7,2.7,0,0,1,1.936-3.279l23.927-6.159a2.7,2.7,0,0,1,3.279,1.936l5.014,19.479A2.7,2.7,0,0,1,422.971,235.259Z",
    transform: "translate(-9180.05 21109.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.971,235.259l-23.927,6.159a2.7,2.7,0,0,1-3.279-1.936L390.752,220a2.7,2.7,0,0,1,1.936-3.279l23.927-6.159a2.7,2.7,0,0,1,3.279,1.936l5.014,19.479A2.7,2.7,0,0,1,422.971,235.259Zm-30.2-18.228a2.378,2.378,0,0,0-1.708,2.893l5.014,19.479a2.378,2.378,0,0,0,2.893,1.708l23.927-6.159a2.378,2.378,0,0,0,1.708-2.893l-5.014-19.479a2.378,2.378,0,0,0-2.893-1.708Z",
    transform: "translate(-9180.05 21109.834)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.782,247.818l-12.076,3.108a.432.432,0,0,1-.524-.272.417.417,0,0,1,.293-.529l12.292-3.164c.5.252.366.766.014.857Z",
    transform: "translate(-9244.432 21079.131)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.225,261.192,471.149,264.3a.432.432,0,0,1-.524-.272.417.417,0,0,1,.293-.529l12.292-3.164c.5.252.366.766.014.857Z",
    transform: "translate(-9247.329 21067.875)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.87,269.216l-3.685.949a.469.469,0,0,1-.571-.337l-1.12-4.349a.469.469,0,0,1,.337-.571l3.685-.949a.469.469,0,0,1,.571.337l1.12,4.349A.469.469,0,0,1,430.87,269.216Z",
    transform: "translate(-9209.349 21064.838)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.287,288.632l-18.43,4.744a.433.433,0,0,1-.524-.272.417.417,0,0,1,.293-.529l18.646-4.8C456.77,288.027,456.639,288.541,456.287,288.632Z",
    transform: "translate(-9219.31 21044.781)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.731,302.01l-18.43,4.744a.433.433,0,0,1-.524-.272.417.417,0,0,1,.293-.529l18.646-4.8C460.213,301.4,460.083,301.919,459.731,302.01Z",
    transform: "translate(-9222.208 21033.523)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.172,315.379l-18.43,4.744a.433.433,0,0,1-.524-.272.416.416,0,0,1,.293-.529l18.646-4.8C463.655,314.774,463.524,315.288,463.172,315.379Z",
    transform: "translate(-9225.104 21022.271)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.615,328.756l-18.43,4.744a.432.432,0,0,1-.524-.272.417.417,0,0,1,.293-.529l18.646-4.8C467.1,328.151,466.968,328.665,466.615,328.756Z",
    transform: "translate(-9228.001 21011.012)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.057,342.126l-18.43,4.744a.433.433,0,0,1-.524-.272.417.417,0,0,1,.293-.529l18.646-4.8C470.54,341.521,470.409,342.035,470.057,342.126Z",
    transform: "translate(-9230.898 20999.76)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.4,455.9a.319.319,0,0,1-.2-.014l0,0-.838-.355a.321.321,0,1,1,.251-.591l.543.231.712-1.674a.321.321,0,0,1,.421-.17h0l0,.011,0-.011a.322.322,0,0,1,.17.421l-.837,1.968a.321.321,0,0,1-.216.185Z",
    transform: "translate(-9221.706 20905.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.563,293.156H487.7a5.232,5.232,0,0,1-5.226-5.226V239.941a5.232,5.232,0,0,1,5.226-5.226h38.015l8.073,6.435v46.78A5.232,5.232,0,0,1,528.563,293.156Z",
    transform: "translate(-9257.317 21089.438)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.7,244.215a3.726,3.726,0,0,0-3.722,3.722v47.989a3.726,3.726,0,0,0,3.722,3.722h40.862a3.726,3.726,0,0,0,3.722-3.722V249.87l-7.095-5.655Z",
    transform: "translate(-9265.313 21081.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.808,323.069H601.2a.87.87,0,0,1,0-1.741h18.6a.87.87,0,1,1,0,1.741Z",
    transform: "translate(-9356.511 21016.543)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.4,341.616H601.2a.87.87,0,1,1,0-1.741H623.4a.87.87,0,1,1,0,1.741Z",
    transform: "translate(-9356.511 21000.934)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.813,404.443h-18.6a.87.87,0,1,0,0,1.741h18.6a.87.87,0,0,0,0-1.741Z",
    transform: "translate(-9356.515 20946.592)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.4,422.993H601.21a.87.87,0,1,0,0,1.741H623.4a.87.87,0,1,0,0-1.741Z",
    transform: "translate(-9356.515 20930.979)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.808,489.3H601.2a.87.87,0,0,1,0-1.741h18.6a.87.87,0,1,1,0,1.741Z",
    transform: "translate(-9356.511 20876.635)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.4,507.851H601.2a.87.87,0,0,1,0-1.741H623.4a.87.87,0,0,1,0,1.741Z",
    transform: "translate(-9356.511 20861.025)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.076,
    cy: 3.076,
    r: 3.076,
    transform: "translate(-8766.129 21337.135)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.442,331.074a.319.319,0,0,1-.192-.064l0,0-.723-.553a.321.321,0,0,1,.391-.51l.468.359,1.107-1.444a.321.321,0,0,1,.45-.059h0l-.007.01.007-.01a.322.322,0,0,1,.059.45l-1.3,1.7a.321.321,0,0,1-.256.125Z",
    transform: "translate(-9312.799 21010.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.642,402.862a3.076,3.076,0,0,1-3.076,3.077.659.659,0,0,1-.079,0,3.076,3.076,0,1,1,3.155-3.074Z",
    transform: "translate(-9305.303 20950.512)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.076,
    cy: 3.076,
    r: 3.076,
    transform: "translate(-8766.129 21363.461)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.627,242H756.3a1.741,1.741,0,0,1-1.741-1.741v-4.671a.109.109,0,0,1,.176-.085l7.956,6.3a.109.109,0,0,1-.068.194Z",
    transform: "translate(-9486.312 21088.793)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.334,405.314a.873.873,0,0,1,.871-.871h4.636a6.586,6.586,0,0,1,.572,1.741h-5.208a.871.871,0,0,1-.871-.869Z",
    transform: "translate(-9356.511 20946.592)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.525,422.993a6.637,6.637,0,0,1-.231,1.741H601.21a.87.87,0,1,1,0-1.741Z",
    transform: "translate(-9356.515 20930.979)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.434,454.114a1.756,1.756,0,0,1-2.414.585l-20.49-12.5a1.756,1.756,0,1,1,1.829-3l20.49,12.5A1.756,1.756,0,0,1,654.434,454.114Z",
    transform: "translate(-9354.871 20943.951)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.872,396.435a14.05,14.05,0,1,1-4.678-19.31A14.05,14.05,0,0,1,578.872,396.435Zm-20.99-12.8a10.537,10.537,0,1,0,14.483-3.509,10.537,10.537,0,0,0-14.483,3.509Z",
    transform: "translate(-9299.799 20989.131)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11362.927 -22758.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.361,225.188a1.257,1.257,0,0,1-.929-.411l-13.942-15.21a1.692,1.692,0,0,0-1.244-.547H158.57a4.222,4.222,0,0,1-4.217-4.217V178.233a4.222,4.222,0,0,1,4.217-4.217h95.453a4.222,4.222,0,0,1,4.217,4.217V204.8a4.222,4.222,0,0,1-4.217,4.217h-2.706a1.689,1.689,0,0,0-1.687,1.687v13.215a1.257,1.257,0,0,1-.806,1.179,1.271,1.271,0,0,1-.462.087Z",
    transform: "translate(-10598.965 23150.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.361,225.188a1.257,1.257,0,0,1-.929-.411l-13.942-15.21a1.692,1.692,0,0,0-1.244-.547H158.57a4.222,4.222,0,0,1-4.217-4.217V178.233a4.222,4.222,0,0,1,4.217-4.217h95.453a4.222,4.222,0,0,1,4.217,4.217V204.8a4.222,4.222,0,0,1-4.217,4.217h-2.706a1.689,1.689,0,0,0-1.687,1.687v13.215a1.257,1.257,0,0,1-.806,1.179,1.271,1.271,0,0,1-.462.087Zm-89.791-50.61a3.659,3.659,0,0,0-3.655,3.655V204.8a3.659,3.659,0,0,0,3.655,3.655h73.676a2.254,2.254,0,0,1,1.658.729l13.942,15.21a.7.7,0,0,0,1.221-.475V210.707a2.252,2.252,0,0,1,2.249-2.249h2.706a3.659,3.659,0,0,0,3.655-3.655V178.233a3.659,3.659,0,0,0-3.655-3.655Z",
    transform: "translate(-10598.965 23150.598)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.69,
    cy: 3.69,
    r: 3.69,
    transform: "translate(-10437.958 23328.953)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.49,265.2H179.648a1.968,1.968,0,0,1,0-3.936H266.49a1.968,1.968,0,1,1,0,3.936Z",
    transform: "translate(-10615.738 23087.867)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.2,235.427H179.648a1.968,1.968,0,0,1,0-3.936H238.2a1.968,1.968,0,1,1,0,3.936Z",
    transform: "translate(-10615.738 23109.273)",
    fill: "#4f7777"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6120.976 -22260.514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M579.346,300.885a5.732,5.732,0,0,1-5.726-5.726V282.726a5.726,5.726,0,0,1,11.452,0v12.433A5.732,5.732,0,0,1,579.346,300.885Z",
    transform: "translate(-5678.12 22595.5)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.226,337.588a12.12,12.12,0,0,1-12.106-12.106.982.982,0,0,1,1.963,0,10.143,10.143,0,1,0,20.286,0,.982.982,0,1,1,1.963,0A12.12,12.12,0,0,1,566.226,337.588Z",
    transform: "translate(-5665 22563.541)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.1,372.26a.982.982,0,0,1-.982-.981v-10.8a.982.982,0,0,1,1.963,0v10.8a.982.982,0,0,1-.982.982Z",
    transform: "translate(-5687.875 22539.994)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.654,
    cy: 0.654,
    r: 0.654,
    transform: "translate(-5101.719 22875.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.654,
    cy: 0.654,
    r: 0.654,
    transform: "translate(-5101.719 22881.824)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.654,
    cy: 0.654,
    r: 0.654,
    transform: "translate(-5097.138 22877.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.888,395h-15.55a.982.982,0,1,1,0-1.963h15.55a.982.982,0,1,1,0,1.963Z",
    transform: "translate(-5671.887 22517.43)",
    fill: "#4f7777"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1099.421 -6.914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.07,259.389c-6.109,3.366-11.313,1.009-16.351,5.832a19.089,19.089,0,0,0-.757-12.909c-.6-1.393-1.88-7.747-1.45-9.2.424-1.04,6.8-.723,9.034-2.057,1.558-.932,4.761-3.413,6.549-3.143.094,2.416.143,4.575,1.2,6.833C345.547,245.277,348.124,258.808,347.07,259.389Z",
    transform: "translate(-159.654 -34.452)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.856,67.647l-16.348.487-3.414,3.727L177.9,91.99v31.834s-6.347,11.235-2.885,21.067c3.7,10.508,16.734-1.895,26.543-.479s25.389,2.82,25.389,2.82l-9.232-34.175,7.279-39.991-9.155-9.417-12.983,4Z",
    transform: "translate(-26.071 148.432)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.53 215.745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.609,95.24c-3.271-2.819-4.467-6.792-2.672-8.873s5.9-1.482,9.171,1.339a10.806,10.806,0,0,1,3.026,4.11l13.707,12.121-5.825,6.311L102.122,97.629a10.807,10.807,0,0,1-4.512-2.388Z",
    transform: "translate(-94.103 -83.985)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.146,83.715l9.029-.821,7.918,37.762A13.079,13.079,0,0,1,159.653,136.2l-6.507,1.195-41.476-36.518,6.06-10.1,30.587,19.187,4.83-26.25Z",
    transform: "translate(-102.684 -82.895)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.664 248.932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.985,412.812s-8.247,15.315-7.658,14.726,10.6,2.945,10.6,2.945l5.891-15.315Z",
    transform: "translate(-118.482 -259.923)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.016,230.817s-4.221,16.875-3.8,16.159,11,.244,11,.244l1.938-16.294-9.144-.108Z",
    transform: "translate(-112.684 -185.133)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.123,218.731c-18.637,2.618-35.47.335-49.186-10.419,0,0-10.014,33.576,8.247,37.11s38.583-2.54,40.939-8.431S221.123,218.731,221.123,218.731Z",
    transform: "translate(-130.358 -175.884)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6,244l-20.322,47.9-9.425,55.371,12.37,2.945,22.127-50.953,30-48.781Z",
    transform: "translate(-121.585 -190.55)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.734,193.053s-4.712-36.521-13.548-38.878a28.847,28.847,0,0,0-11.332-.622,7.016,7.016,0,0,0-5.956,5.73l-8.03,45.661h11.354l3.655-12.37,9.719,16.972,14.137-16.493Z",
    transform: "translate(-113.374 -153.261)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759,248.629l-11.227-1.178-1.732,6.48s-18.261,16.494-8.836,17.672,18.261-5.3,18.261-5.3l12.965-7.437s-5.013-13.364-8.547-13.364S127.759,248.629,127.759,248.629Z",
    transform: "translate(-103.262 -191.167)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.759,435.718l-11.227-1.178-1.732,6.48s-18.261,16.493-8.836,17.672,18.261-5.3,18.261-5.3l12.965-7.437S146.3,432,142.766,432,137.759,435.718,137.759,435.718Z",
    transform: "translate(-107.372 -267.808)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(181.793 216.027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.517,265.135c-1.234,4.231-4.416,7.023-7.108,6.238s-3.874-4.851-2.64-9.083a11.028,11.028,0,0,1,2.536-4.55l5.453-17.859,8.326,2.738-6.259,17.315a11.03,11.03,0,0,1-.307,5.2Z",
    transform: "translate(-232.279 -154.484)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.7,82.014l-4.342-1.224h0a49.4,49.4,0,0,0-5.086,26.348l2.143,25.347-7.07,44.552,13.858,3.585,10.92-55.91L249.7,82.014Z",
    transform: "translate(-233.699 -80.789)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.095 203.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.608,85.267l-.577-18.206a1.054,1.054,0,0,1,1.117-1.086l14.447.866a1.055,1.055,0,0,1,.982,1.194l-2.444,18.1a1.057,1.057,0,0,1-1.115.911l-11.426-.756a1.062,1.062,0,0,1-.329-.075,1.051,1.051,0,0,1-.656-.944Z",
    transform: "translate(-80.282 -62.32)",
    fill: "#4f7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.334,61.869c.2-.021.473-.047.8-.075a.83.83,0,0,1-.085-.55l.258-1.364a.834.834,0,0,1,.709-.673c2.127-.284,9.444-1.056,14.051,1.034a.831.831,0,0,1,.483.734l.042,1.455a.83.83,0,0,1-.139.485c.383.1.765.212,1.143.331a.631.631,0,0,1,.436.531l.072.62a.633.633,0,0,1-.672.7L80.158,63.936a.633.633,0,0,1-.572-.784l.2-.8A.634.634,0,0,1,80.334,61.869Z",
    transform: "translate(-79.567 -58.832)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 14.621,
    cy: 14.621,
    r: 14.621,
    transform: "translate(160.951 182.333)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.383,429.529l.291-1.566-3.916-.727s-5.538-5.079-11.893-1.4-9.14,5.595-9.14,5.595l-2.931,2.7,2.2,1.219-2.786,1.913,2.349.436-2,2.059,3.3,6.689s.616-5.962,5.315-5.089,11.344-4.376,11.344-4.376l10.148,10.8s.085-4.822,2.828-4.324C881.5,443.452,884.853,431.911,876.383,429.529Z",
    transform: "translate(-690.789 -247.586)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawVibeCodingMjme);
export default __webpack_public_path__ + "static/media/undraw_vibe-coding_mjme.f482197c6188fba449116951dbec67f0.svg";
export { ForwardRef as ReactComponent };